import { HttpBackend, HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
//import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly JWT_TOKEN = 'JWT_TOKEN';
  private readonly REFRESH_TOKEN = 'REFRESH_TOKEN';
  private readonly TOKEN_Expiry = 'TOKEN_Expiry';
  private loggedUser: string;
  private _baseUrl: string;

  constructor(private http: HttpClient, handler: HttpBackend) {
    this._baseUrl = "";//environment.baseurl;
    this.http = new HttpClient(handler);
  }

  isLoggedIn() {
    return !!this.getJwtToken();
  }


  refreshToken(): Observable<any[]> {
    const reqHeader = new HttpHeaders({ 'Anonymous': ''});
    return this.http.post<any[]>(this._baseUrl + '/LoginPage/Refresh', { 'refreshToken': "" }, { headers: reqHeader })
      .pipe(tap((tokens: any[]) => { this.storeTokens(tokens); }));
}
getJwtToken() {
  return localStorage.getItem(this.JWT_TOKEN);
}

  private doLoginUser(username: string, tokens: Tokens) {
  this.loggedUser = username;
  this.storeTokens(tokens);
}

  private doLogoutUser() {
  this.loggedUser = null;
  this.removeTokens();
}

getRefreshToken() {
  return localStorage.getItem(this.REFRESH_TOKEN);
}

  private storeJwtToken(jwt) {
  localStorage.setItem(this.JWT_TOKEN, jwt);
}

  private storeTokens(tokens: any) {
  localStorage.setItem(this.JWT_TOKEN, tokens.token);
  localStorage.setItem(this.REFRESH_TOKEN, tokens.refToken.token);
  localStorage.setItem(this.TOKEN_Expiry, tokens.expiration);
}

  private removeTokens() {
  localStorage.removeItem(this.JWT_TOKEN);
  localStorage.removeItem(this.REFRESH_TOKEN);
  localStorage.removeItem('AcceptedT&C');
}
}
export class Tokens {
  token: string
  refToken: string
  expiration: string
}
